import { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { useRef } from "react";

import { useNavigate } from "react-router-dom";

import aboutHero from "../../../assets/Scenic-train-ride.jpg";

import dhamma from "../../../assets/tea-estate.jpg";
import sigiriya from "../../../assets/ella.jpg";
import kandy from "../../../assets/Scenic-train-ride.jpg";
import temple from "../../../assets/Horton-Plains-National-Park.jpg";

import related1 from "../../../assets/kumana_park.jpg";
import related2 from "../../../assets/train-sri-lanka.jpg";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";

function SriLankaHillCountryTour() {

    const swiperRef = useRef(null);

    const navigate = useNavigate();

    const images = [dhamma, sigiriya, kandy, temple];

    const [selectedImage, setSelectedImage] = useState(images[0]);

    const [day1, setDay1] = useState(true);
    const [day2, setDay2] = useState(false);
    const [day3, setDay3] = useState(false);

    useEffect(() => {
        AOS.init({ duration: 1000, once: true });
    }, []);

    return (
        <div className="w-full overflow-hidden">

            {/* ================= HERO ================= */}
            <section className="relative h-[40vh] w-full">
                <div
                    className="absolute inset-0 bg-fill bg-center"
                    style={{ backgroundImage: `url(${aboutHero})` }}
                />
                <div className="absolute inset-0 bg-black/60" />

                <div className="relative z-10 flex h-full flex-col items-center justify-center text-center text-white">
                    <h1
                        data-aos="fade-up"
                        className="text-3xl sm:text-4xl md:text-5xl lg:text-4xl font-extrabold leading-tight"
                    >
                        Sri Lanka Hill Country Tour – 3 Days
                    </h1>
                    <p
                        data-aos="fade-up"
                        data-aos-delay="150"
                        className="mt-4 sm:mt-6 max-w-full sm:max-w-2xl md:max-w-3xl text-sm sm:text-base md:text-lg"
                    >
                        Where Sri Lanka’s heart meets the hills.
                    </p>
                </div>
            </section>

            {/* ================= CULTURAL HIGHLIGHTS ================= */}
            <section className="bg-white -py-2">
                <div className="mx-auto max-w-7xl px-6 text-center">

                    <p
                        data-aos="fade-up"
                        data-aos-delay="150"
                        className="mx-auto mt-6 max-w-4xl text-gray-600 leading-relaxed"
                    >
                        Offering a nonstop adventure in Sri Lanka, vacation tours to the hill country include thrilling excursions and enriching experiences. On this special tour, you can explore the citadel of Kandy with its famed Buddhist temple and wander along tea-covered slopes in Nuwara Eliya. You can also look forward to a rendezvous with elephants in Pinnawala and enjoy the adrenaline rush of white water rafting amidst spectacular natural beauty.
                    </p>

                    {/* Duration Bar */}
                    <div
                        data-aos="fade-up"
                        data-aos-delay="250"
                        className="mx-auto mt-10 flex max-w-4xl items-center justify-center rounded-md bg-gradient-to-r from-[#0A3A5E] to-[#1C6EA4] py-5 text-white"
                    >
                        <div className="flex items-center gap-4">
                            <span className="text-3xl">📅</span>
                            <div className="text-left">
                                <p className="text-sm uppercase tracking-widest">Duration</p>
                                <p className="text-xl font-bold">03 Days / 02 Nights</p>
                            </div>
                        </div>
                    </div>

                    {/* Main Image */}
                    <div
                        data-aos="zoom-in"
                        data-aos-delay="300"
                        className="mx-auto mt-10 overflow-hidden rounded-xl shadow-xl"
                    >
                        <img
                            src={selectedImage}
                            alt="Selected Tour"
                            className="h-[420px] w-full object-fill transition duration-500"
                        />
                    </div>

                    {/* Thumbnail Gallery */}
                    <div
                        data-aos="fade-up"
                        data-aos-delay="400"
                        className="mx-auto mt-8 grid max-w-5xl grid-cols-2 gap-4 sm:grid-cols-4"
                    >
                        {images.map((img, index) => (
                            <img
                                key={index}
                                src={img}
                                onClick={() => setSelectedImage(img)}
                                className={`h-28 w-full cursor-pointer rounded-lg object-cover transition-all duration-300 
                                hover:scale-105
                                ${selectedImage === img ? "ring-4 ring-[#0A3A5E]" : "opacity-70"}
                            `}
                            />
                        ))}
                    </div>

                </div>
            </section>

            {/* ================= TOUR ITINERARY ================= */}
            <section className="bg-gray-50 py-10">
                <div className="mx-auto max-w-6xl px-6">

                    <h2
                        data-aos="fade-up"
                        className="text-center text-3xl sm:text-4xl md:text-5xl lg:text-4xl font-extrabold leading-tight"
                    >
                        Tour Itinerary
                    </h2>

                    <div className="mt-12 space-y-6">

                        {/* ================= DAY 1 ================= */}
                        <div data-aos="fade-up" className="overflow-hidden rounded-lg border bg-white shadow">
                            <button
                                onClick={() => setDay1(!day1)}
                                className="flex w-full items-center justify-between bg-gray-100 px-6 py-5 text-left font-semibold text-[#0A3A5E]"
                            >
                                <span>Day 01 - Airport | Kandy</span>
                                <span>{day1 ? "−" : "+"}</span>
                            </button>

                            {day1 && (
                                <div className="space-y-4 px-6 py-6 text-gray-700 leading-relaxed">
                                    <p>
                                        Arrival at the Bandaranaike International Airport where you will be met by an Aitken Spence representative or a tour guide and transfer to Kandy.
                                    </p>

                                    <p>
                                        Go on a city tour of Kandy in the afternoon. Last ruled by King Sri Wickrama Rajasinghe, before it was brought under the British rule in 1815, this city was the final royal capital of Sri Lankan kings. A UNESCO World Heritage Site, it has a rich culture, history and heritage and attracts travellers from around the world.
                                    </p>

                                    <p>
                                        Explore the bustling town centre home to a colourful bazaar, world-class brands, an arts & crafts centre and a gem museum and lapidary. Drive towards the Victoria Golf Course, undoubtedly one of the best golf courses in the world, with a unique class and style of its own. Alternatively, take a stroll amidst the vibrant colour of the fresh fruits and vegetables in the Kandy Market. Fine tune your evening by stepping to the beat of traditional music and drumming amplified by a cultural show that enhances the rich and vibrant culture of the Wonder of Asia, Sri Lanka.
                                    </p>

                                    <p>
                                        Thereafter visit the Royal Botanical Gardens in Peradeniya, a flourishing national asset. First developed as a pleasure garden under royalty and later improved upon by the British, the gardens are located just four miles from Kandy and feature the most welcoming facilities as well. Walk into this 147-acre haven for an experience of bliss, passing well-tended lawns, pavilions and an octagon conservatory. Be greeted by the vast expanse of magnificently landscaped, lush green turf which will encourage you to take an exhilarating break. Towards the north of the entrance is a cafeteria that one might come across, before heading to some of the highlights here; this includes the Orchid House and the giant Javan fig tree, each with their own sense of grace and beauty.
                                    </p>

                                    <p>
                                        In the evening, visit the Temple of the Sacred Tooth Relic in Kandy. Experience an ancient Kandyan legacy engraved around its crown jewel – a historic temple that houses the Sacred Tooth Relic of Lord Buddha. Thereafter, proceed to an auditorium to witness a captivating cultural show.
                                    </p>

                                    <p>
                                        Once the day is done, head back to the hotel to unwind and enjoy a delectable dinner.
                                    </p>

                                    <p className="font-semibold">Overnight stay in kandy</p>

                                </div>
                            )}
                        </div>

                        {/* ================= DAY 2 ================= */}
                        <div data-aos="fade-up" data-aos-delay="150" className="overflow-hidden rounded-lg border bg-white shadow">
                            <button
                                onClick={() => setDay2(!day2)}
                                className="flex w-full items-center justify-between bg-gray-100 px-6 py-5 text-left font-semibold text-[#0A3A5E]"
                            >
                                <span>Day 02 - Kandy | Pinnawala | Nuwara Eliya</span>
                                <span>{day2 ? "−" : "+"}</span>
                            </button>

                            {day2 && (
                                <div className="space-y-4 px-6 py-6 text-gray-700 leading-relaxed">
                                    <p>
                                        After breakfast, proceed to Nuwara Eliya.
                                    </p>

                                    <p>
                                        En route visit the Pinnawala Elephant Orphanage; as you enter the 25-acre property, do not be surprised when you get the chance to witness baby elephants being bottle fed or see them walk around freely causing absolutely no harm to anyone. It is a sincerely moving sight to observe how these orphaned gentle giants, some of which have only three legs due to injury, are taken care of here.
                                    </p>

                                    <p>
                                        Established in 1975, this orphanage for elephants has to date seen over 20 calves been born; it may surprise you to know that some of the elephants have even lived to see their “grandchildren” being born!
                                    </p>

                                    <p>
                                        Those who visit at 09:15am and 01:15pm can enjoy the sight of cute baby elephants during milk feeding time. Also not to be missed is the daily bath time at the nearby river which takes place at 10:00am and 02:00pm, offering plenty of memorable moments.
                                    </p>

                                    <p>
                                        Proceed to Nuwara Eliya where you can check-in to your hotel and look forward to a hearty dinner and a blissful night’s sleep.
                                    </p>

                                    <p className="font-semibold">Overnight stay in Nuwara Eliya.</p>

                                </div>
                            )}
                        </div>

                        {/* ================= DAY 3 ================= */}
                        <div
                            data-aos="fade-up"
                            data-aos-delay="300"
                            className="overflow-hidden rounded-lg border bg-white shadow"
                        >
                            <button
                                onClick={() => setDay3(!day3)}
                                className="flex w-full items-center justify-between bg-gray-100 px-6 py-5 text-left font-semibold text-[#0A3A5E]"
                            >
                                <span>Day 03 - Nuwara Eliya | Kitulgala | Selected Beach Resort</span>
                                <span>{day3 ? "−" : "+"}</span>
                            </button>

                            {day3 && (
                                <div className="space-y-5 px-6 py-6 text-gray-700 leading-relaxed">

                                    <p>
                                        After a delicious breakfast, it’s time to explore Nuwara Eliya.
                                    </p>

                                    <p>
                                        Misty steep roads, twisting through lush green blankets of tea bushes in a cool climate, remind visitors that they are within the range of the renowned British colonial retreat, Nuwara Eliya. Augmented by an English countryside atmosphere, the “City of Light” - once governed by English and Scottish planters - is still studded with colonial bungalows, hedgerows and one of the finest 18-hole golf courses in the world. A hike through the green grass and past redbrick walls should present breathtaking views of a buzzing countryside hamlet.
                                    </p>

                                    <p>
                                        Hop into a rattling train, smoking and hissing its way through green valleys of the hill country pierced by endless waterfalls and dotted by tea pluckers draped in bright-coloured saris. Or rent a bike for a gentle ride along the banks splashed by the waters of Lake Gregory.
                                    </p>

                                    <p>
                                        On completion of your excursion, transfer to a beach resort via Kitulgala.
                                    </p>

                                    <p>
                                        Showered by two monsoons each year, Kitulgala - the destination of the acclaimed movie 'The Bridge on the River Kwai' - marks an important period in many calendars as one of the wettest places in Sri Lanka. If adventure close to Colombo is your pick, then Kitulgala is your bliss!
                                    </p>

                                    <p>
                                        Grab your gear and toss into the wild rapids for a seamless rafting challenge on white water, thundering downstream, gushing and splashing far and wide. Hop from rock to rock upstream for a mind-blowing waterfall jump that should strain your voice to the core or slide down to the darkest depths of caves haunted by millions of bats. If hardcore adventurism is not for you, then simply trek along the beaten track to admire the immaculate beauty of the wilderness.
                                    </p>

                                </div>
                            )}
                        </div>

                    </div>
                </div>
            </section>

            {/* ================= ROUTE MAP ================= */}
            <section className="bg-white -py-2">
                <div className="mx-auto max-w-7xl px-6">

                    <div
                        className="ch-left mx-auto max-w-5xl"
                        data-aos="fade-right"
                    >
                        <h1
                            data-aos="fade-up"
                            className="mb-6 text-center text-3xl sm:text-4xl md:text-5xl lg:text-4xl font-extrabold leading-tight"
                        >
                            Route
                        </h1>

                        <div className="flex flex-col lg:flex-row gap-6">

                            <div className="map-container flex-1 overflow-hidden rounded-xl shadow-xl border">
                                <iframe
                                    width="100%"
                                    height="450"
                                    style={{ border: 0 }}
                                    loading="lazy"
                                    allowFullScreen
                                    src="https://www.google.com/maps/embed/v1/directions?key=AIzaSyBjUk_Sn0lthNO_cpZO9n5hI1lmZPRUB0E
                                    &origin=Bandaranaike+International+Airport+Sri+Lanka
                                    &destination=Southern+Province+Beach+Resort+Sri+Lanka
                                    &waypoints=Kandy+Sri+Lanka|Pinnawala+Elephant+Orphanage|Nuwara+Eliya+Sri+Lanka"
                                />
                            </div>

                            {/* Route Info */}
                            <div className="route-info w-full h-[120px] lg:w-[300px] flex flex-col items-start gap-3 rounded-lg bg-gray-100 p-5 text-lg shadow">
                                <p><strong>Distance:</strong> ~520 km</p>
                                <p><strong>Driving Time:</strong> ~14–16 hours</p>
                            </div>

                        </div>

                    </div>

                </div>
            </section>

            {/* ================= IMPORTANT INFO + CTA ================= */}
            <section className="bg-white py-10">
                <div className="mx-auto max-w-7xl px-6">

                    {/* Important Points */}
                    <div data-aos="fade-up" className="mx-auto max-w-4xl">
                        <h3 className="mb-6 text-center text-2xl font-bold text-[#0A3A5E]">
                            Important points to note
                        </h3>

                        <ul className="space-y-4 text-gray-700">
                            <li className="flex items-start gap-3">
                                <span className="mt-1 text-[#0A3A5E]">◆</span>
                                <p>
                                    After making the payment, any booking cannot be cancelled.
                                    Hence, once the payment is made it will not be refunded.
                                </p>
                            </li>

                            <li className="flex items-start gap-3">
                                <span className="mt-1 text-[#0A3A5E]">◆</span>
                                <p>
                                    Additional services and excursions that are optional may be provided,
                                    though for an additional charge.
                                </p>
                            </li>

                            <li className="flex items-start gap-3">
                                <span className="mt-1 text-[#0A3A5E]">◆</span>
                                <p>
                                    The official check-in time at all hotels is at 12:00 pm.
                                </p>
                            </li>

                            <li className="flex items-start gap-3">
                                <span className="mt-1 text-[#0A3A5E]">◆</span>
                                <p>
                                    The official check-out time at all hotels is at 11:00 am.
                                </p>
                            </li>

                            <li className="flex items-start gap-3">
                                <span className="mt-1 text-[#0A3A5E]">◆</span>
                                <p>
                                    Visits to wildlife parks will be at one’s own risk. Jeeps and vehicles
                                    available here are without air conditioning and come with basic insurance
                                    covers (not comprehensive as in the case of vehicles used for our tours).
                                </p>
                            </li>
                        </ul>
                    </div>

                    {/* CTA Box */}
                    <div
                        data-aos="zoom-in"
                        className="mt-10 w-full rounded-lg bg-gray-100 px-6 py-10 text-center shadow"
                    >
                        <h2 className="mb-6 text-xl sm:text-2xl font-semibold text-gray-800">
                            Experience your dream holiday in Sri Lanka!
                        </h2>

                        <button
                            onClick={() => navigate(`/contact`)}
                            className="rounded-full bg-[#00A9C7] px-10 py-3 text-white font-semibold transition hover:bg-[#008eaa]">
                            BEGIN YOUR JOURNEY
                        </button>
                    </div>

                    {/* Related Destinations */}
                    <div data-aos="fade-up" className="mt-10 text-left">
                        <h3 className="mb-6 text-xl font-bold text-gray-700">
                            RELATED DESTINATIONS
                        </h3>

                        <div className="flex flex-wrap justify-start gap-3">
                            {[
                                "Colombo Airport",
                                "Kandy",
                                "Pinnawala",
                                "Nuwara Eliya",
                                "Kitulgala",
                                "Bentota",
                                "Hikkaduwa",
                                "Mirissa",
                                "Unawatuna",
                                "Galle",
                                "Selected Beach Resort"
                            ].map((place, i) => (
                                <span
                                    key={i}
                                    className="cursor-pointer rounded-full bg-gray-200 px-5 py-2 text-sm font-medium text-gray-700 transition hover:bg-[#0A3A5E] hover:text-white"
                                >
                                    {place}
                                </span>
                            ))}
                        </div>
                    </div>

                </div>
            </section>

            {/* ================= RELATED TOURS ================= */}
            <section className="bg-white py-5">
                <div className="mx-auto max-w-7xl px-6">

                    <div className="mb-5 flex items-center justify-between" data-aos="fade-up">
                        {/* Heading */}
                        <h2 className="text-3xl sm:text-4xl font-extrabold tracking-wide text-gray-800">
                            RELATED TOURS
                        </h2>

                        {/* Slider Arrows */}
                        <div className="flex gap-3">
                            <button
                                onClick={() => swiperRef.current.slidePrev()}
                                className="flex h-10 w-10 items-center justify-center rounded-full border border-gray-300 transition hover:bg-[#083A5E] hover:text-white"
                            >
                                ‹
                            </button>

                            <button
                                onClick={() => swiperRef.current.slideNext()}
                                className="flex h-10 w-10 items-center justify-center rounded-full bg-[#00A9C7] text-white transition hover:bg-[#008eaa]"
                            >
                                ›
                            </button>
                        </div>
                    </div>

                    <Swiper
                        modules={[Navigation, Autoplay]}
                        onSwiper={(swiper) => (swiperRef.current = swiper)}
                        autoplay={{
                            delay: 3500,
                            disableOnInteraction: false,
                        }}
                        loop={true}
                        spaceBetween={30}
                        breakpoints={{
                            0: { slidesPerView: 1 },
                            640: { slidesPerView: 2 },
                            1024: { slidesPerView: 3 },
                        }}
                    >

                        {/* Slide 1 */}
                        <SwiperSlide>
                            <div className="group overflow-hidden rounded-xl shadow-lg">
                                <div className="relative h-[260px] overflow-hidden">
                                    <img
                                        src={related1}
                                        alt="Special Tours To Sri Lanka"
                                        className="h-full w-full object-cover transition duration-700 group-hover:scale-110"
                                    />
                                </div>

                                <div className="bg-[#083A5E] p-6 text-center">
                                    <h3 className="mb-4 text-lg font-semibold text-white">
                                        Culture, Hill Country And Wild Life Tour
                                    </h3>
                                    <button
                                        onClick={() => navigate(`/tours/hill-country/culture-hill-country-and-wild-life-tour`)}
                                        className="border-b-2 border-[#00A9C7] pb-1 text-sm uppercase tracking-widest text-[#00A9C7] hover:text-white">
                                        View Details
                                    </button>
                                </div>
                            </div>
                        </SwiperSlide>

                        {/* Slide 2 */}
                        <SwiperSlide>
                            <div className="group overflow-hidden rounded-xl shadow-lg">
                                <div className="relative h-[260px] overflow-hidden">
                                    <img
                                        src={related2}
                                        alt="Mini Tour Packages"
                                        className="h-full w-full object-cover transition duration-700 group-hover:scale-110"
                                    />
                                </div>

                                <div className="bg-[#083A5E] p-6 text-center">
                                    <h3 className="mb-4 text-lg font-semibold text-white">
                                        Tour in the Hills
                                    </h3>
                                    <button
                                        onClick={() => navigate(`/tours/hill-country/tour-in-the-hills`)}
                                        className="border-b-2 border-[#00A9C7] pb-1 text-sm uppercase tracking-widest text-[#00A9C7] hover:text-white">
                                        View Details
                                    </button>
                                </div>
                            </div>
                        </SwiperSlide>

                    </Swiper>

                </div>
            </section>

            {/* ================= WHATSAPP ================= */}
            <a
                href="https://wa.me/94743412910"
                target="_blank"
                rel="noopener noreferrer"
                className="fixed bottom-5 right-5 z-50"
            >
                <img
                    src="https://upload.wikimedia.org/wikipedia/commons/thumb/6/6b/WhatsApp.svg/512px-WhatsApp.svg.png"
                    alt="WhatsApp"
                    className="h-12 w-12 rounded-full shadow-lg transition hover:scale-110 sm:h-14 sm:w-14"
                />
            </a>

        </div>
    );
}

export default SriLankaHillCountryTour;
